module.exports = __webpack_public_path__ + "img/Generaxion_OPN_Bogmærk_Hvid_pink_gradient.af8f5391.svg";